var mentions_default = {
  "mentionPalette": "ubU3Y",
  "mention": "JoLCM",
  "mentionViewer": "NawJw",
  "mentionSuggestionsEntry": "_7aobe",
  "mentionSuggestionsEntryFocused": "MdQR-",
  "mentionSuggestionsEntryText": "niT7t",
  "mentionSuggestionsEntryAvatar": "VLETM",
  "mentionSuggestions": "iAP7d",
  "cursorDefault": "E7ZZr",
  "cursorPointer": "hbzh2"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
